import React from "react";
import PropTypes from "prop-types";
import { Form, List } from "semantic-ui-react";
import { strings } from "../../resources";
import {
  SignatureFieldContainer,
  DoctorSignatureContainer,
} from "../../../Images/containers";
import { DatePicker } from "../ui";
import { dateEpochToDateTimeString } from "../../../App/helpers/DateTimeFormatConversion";

const complications = [
  {
    header: strings.form.consentWording.upperBlepharoplastyBlurredVisionHeader,
    content:
      strings.form.consentWording.upperBlepharoplastyBlurredVisionContent,
  },
  {
    header: strings.form.consentWording.upperBlepharoplastyWateryEyesHeader,
    content: strings.form.consentWording.upperBlepharoplastyWateryEyesContent,
  },
  {
    header: strings.form.consentWording.upperBlepharoplastyDryEyesHeader,
    content: strings.form.consentWording.upperBlepharoplastyDryEyesContent,
  },
  {
    header: strings.form.consentWording.upperBlepharoplastySurfaceInjuryHeader,
    content:
      strings.form.consentWording.upperBlepharoplastySurfaceInjuryContent,
  },
  {
    header: strings.form.consentWording.upperBlepharoplastyBleedingHeader,
    content: strings.form.consentWording.upperBlepharoplastyBleedingContent,
  },
  {
    header: strings.form.consentWording.upperBlepharoplastyMuscleDamageHeader,
    content: strings.form.consentWording.upperBlepharoplastyMuscleDamageContent,
  },
  {
    header: strings.form.consentWording.upperBlepharoplastyPtosisHeader,
    content: strings.form.consentWording.upperBlepharoplastyPtosisContent,
  },
  {
    header: strings.form.consentWording.upperBlepharoplastyCorneaExposureHeader,
    content:
      strings.form.consentWording.upperBlepharoplastyCorneaExposureContent,
  },
  {
    header: strings.form.consentWording.upperBlepharoplastySunkenHeader,
    content: strings.form.consentWording.upperBlepharoplastySunkenContent,
  },
  {
    header: strings.form.consentWording.upperBlepharoplastyGlaucomaHeader,
    content: strings.form.consentWording.upperBlepharoplastyGlaucomaContent,
  },
  {
    header: strings.form.consentWording.upperBlepharoplastyInfectionHeader,
    content: strings.form.consentWording.upperBlepharoplastyInfectionContent,
  },
  {
    header: strings.form.consentWording.upperBlepharoplastyAsymmetryHeader,
    content: strings.form.consentWording.upperBlepharoplastyAsymmetryContent,
  },
  {
    header: strings.form.consentWording.upperBlepharoplastyScarringHeader,
    content: strings.form.consentWording.upperBlepharoplastyScarringContent,
  },
  {
    header: strings.form.consentWording.upperBlepharoplastyReoperationHeader,
    content: strings.form.consentWording.upperBlepharoplastyReoperationContent,
  },
];

class FormConsentUpperBlepharoplasty extends React.Component {
  componentWillMount = () => {
    if (this.props.mode === "create" || this.props.mode === "edit") {
      let todaysDateStr = dateEpochToDateTimeString(new Date(), "-");
      this.props.updateSelectedForm("date_patient_signed", todaysDateStr);
    }
  };

  render = () => {
    const errorFields = this.props.validationErrors.map((error) => {
      return error.field;
    });
    return (
      <div className="createFormContainer">
        <div className="patientFormSectionHeader">
          {strings.form.header.consentUpperBlepharoplasty}
        </div>
        <div className="personalInformation">
          <Form.Group>
            <Form.Field
              className="textField"
              content={strings.form.consentWording.upperBlepharoplastyOpening}
            />
          </Form.Group>
          <List bulleted>
            {complications.map((complication) => (
              <List.Item key={complication.header}>
                <List.Header>{complication.header}</List.Header>
                {complication.content}
              </List.Item>
            ))}
          </List>
          <Form.Group>
            <Form.Field
              className="textField"
              content={strings.form.consentWording.upperBlepharoplastyClosing}
            />
          </Form.Group>
          <Form.Group>
            <Form.Input
              label={strings.form.label.patientPrintName}
              error={errorFields.includes("signed_by_patient")}
              name="signed_by_patient"
              onChange={this.props.handleChange}
              placeholder={strings.form.placeholder.patientPrintName}
              required
              value={this.props.selectedFormData.signed_by_patient || ""}
              width={8}
            />
          </Form.Group>
          <SignatureFieldContainer
            blank={this.props.mode === "template"}
            headers={this.props.headers}
            error={errorFields.includes("signature_data_url")}
            readOnly={this.props.mode === "create" ? false : true}
            signatureImagePath={
              this.props.formId ? `signatures/forms/${this.props.formId}` : ""
            }
          />
          <Form.Group>
            <DatePicker
              error={errorFields.includes("date_patient_signed")}
              className="datePatientSigned"
              name="date_patient_signed"
              onChange={this.props.handleDateChange}
              onKeyDown={(e) => this.props.handleDateKeyDown(e)}
              required
              label={strings.form.label.datePatientSigned}
              value={this.props.selectedFormData.date_patient_signed || ""}
            />
          </Form.Group>
          {(this.props.selectedFormData.doctor_signature_path ||
            this.props.mode === "template") && (
            <Form.Group>
              <DoctorSignatureContainer
                containerWidth={240}
                containerHeight={150}
                dateDoctorSigned={this.props.dateDoctorSigned}
                doctorName={this.props.doctorName}
                formId={this.props.formId}
                headers={this.props.headers}
                signaturePathAttachedToForm={
                  this.props.selectedFormData.doctor_signature_path
                }
              />
            </Form.Group>
          )}
        </div>
      </div>
    );
  };
}

FormConsentUpperBlepharoplasty.propTypes = {
  mode: PropTypes.string.isRequired, //create, view or edit
  selectedFormData: PropTypes.object.isRequired,
  handleChange: PropTypes.func,
};

export default FormConsentUpperBlepharoplasty;
